<div class="input-group">
    <div class="custom-file">
        <input type="file" class="btn custom-file-input" [title]="fileName" (change)="upload($event)">
        <label class="custom-file-label">
            <div (click)="download($event);">{{ fileName }}</div>
            <ngb-progressbar *ngIf="fileCurrent" type="info" [value]="fileCurrent" [max]="fileSize" height="2px"></ngb-progressbar>
        </label>
    </div>
    <div class="input-group-append">
        <button class="btn input-group-text" [disabled]="!file" (click)="download($event)">Download</button>
    </div>
</div>
